import React, { FunctionComponent } from 'react';
import t from 'rcm-i18n';

interface Props {
    order: any;
}

const ConfirmInfo: FunctionComponent<Props> = (props) => {
    const order = props.order;
    return (
        <>
            <div className="cartHeader checkout-confirm-info-header">
                {t(order.attributes.enrollmentRules.orderIsEnrollment ? 'Mailing Address' : 'Shipping Address')}
            </div>
            <div className="addressInfo checkout-confirm-info-body">
                {order.shipping.data.shipAddress.nameLine}
                {order.status == 'active' &&
                    <a className="edit" href="/secure/checkout/v1#/checkout/address">
                        &nbsp;({t('edit')})
                        </a>
                }
                <div>
                    {order.shipping.data.shipAddress.addressLine1}
                </div>
                <div>
                    {order.shipping.data.shipAddress.addressLine2}
                </div>
                <div>
                    {order.shipping.data.shipAddress.city}
                        &nbsp;{order.shipping.data.shipAddress.formattedState}
                        &nbsp;{order.shipping.data.shipAddress.postalCode}
                </div>
                <div>
                    {order.shipping.data.shipAddress.country}
                </div>
                <div>
                    {t('Phone Number')}:&nbsp;
            {order.shipping.data.shipAddress.formattedPhone}
                </div>
                <div>
                    {
                        order.shipping.data.shipAddress.email ? t('Email') + ': ' + 
                        order.shipping.data.shipAddress.email : null
                    }
                    
                </div>
                {order.attributes.currentShipViaLabel &&
                    <div>
                        {t('Shipping Method')}:&nbsp;{t(order.attributes.currentShipViaLabel)}
                    </div>
                }
            </div>
            <div className="cartHeader checkout-confirm-info-header">
                {t('Billing Address')}
            </div>
            <div className="addressInfo checkout-confirm-info-body">
                {order.billAddress.addressLine1}
                {order.status == 'active' &&
                    <a className="edit" href="/secure/checkout/v1#/checkout/address">
                        &nbsp;({t('edit')})
                        </a>
                }
                <div>
                    {order.billAddress.addressLine2}
                </div>
                <div>
                    {order.billAddress.city}
                        &nbsp;{order.billAddress.formattedState}
                        &nbsp;{order.billAddress.postalCode}
                </div>
                <div>
                    {order.billAddress.country}
                </div>
            </div>
            {
                order.attributes.isPvq &&
                <div className="col-xs-12">
                    {t('Pvq Order: Yes')}
                </div>
            }
            {
                order.shipping.data.isAutoShip &&

                <div className="col-xs-12">
                    {t('Auto Ship')}:&nbsp;{t(order.shipping.data.autoShipIsMonthly ? 'Monthly' : 'Quarterly')}
                </div>
            }
        </>
    );
};

export default ConfirmInfo;